export const Clinic = [
    {type: 'image', url: require('../../../assets/clinic/8.webp')},
    {type: 'image', url: require('../../../assets/clinic/1.webp')},
    {type: 'image', url: require('../../../assets/clinic/14.webp')},
    {type: 'image', url: require('../../../assets/clinic/15.webp')},
    {type: 'image', url: require('../../../assets/clinic/26.jpg')},
    {type: 'image', url: require('../../../assets/clinic/18.webp')},
    {type: 'image', url: require('../../../assets/clinic/19.webp')},
    {type: 'image', url: require('../../../assets/clinic/2.webp')},
    {type: 'image', url: require('../../../assets/clinic/4.webp')},
    {type: 'image', url: require('../../../assets/clinic/5.webp')},
    {type: 'image', url: require('../../../assets/clinic/6.webp')},
    {type: 'image', url: require('../../../assets/clinic/24.jpg')},
    {type: 'image', url: require('../../../assets/clinic/25.jpg')},
    {type: 'image', url: require('../../../assets/clinic/27.jpg')},
    {type: 'image', url: require('../../../assets/clinic/28.jpg')},
    {type: 'image', url: require('../../../assets/clinic/29.jpg')},
    {type: 'image', url: require('../../../assets/clinic/30.jpg')},
]